/* global window, document, fetch, Tabulator */

(function (window, document) {
    'use strict';

    var REGION_KEY = 'vg-funding-region';

    function qs(sel, root) {
        return (root || document).querySelector(sel);
    }

    function apiRoot() {
        var el = qs('[data-vg-funding-map]') || qs('[data-api-base]');
        var base = (el && el.getAttribute('data-api-base')) || '/api';
        return String(base).replace(/\/+$/, '');
    }

    function memberUuid() {
        var el = qs('[data-vg-funding-map][data-member-uuid]') || qs('[data-member-uuid]');
        return el ? (el.getAttribute('data-member-uuid') || '').trim() : '';
    }

    function readRegionSlug() {
        try {
            var raw = localStorage.getItem(REGION_KEY);
            if (!raw) return '';
            var o = JSON.parse(raw);
            if (o && o.slug && o.slug !== '__national__') {
                return String(o.slug).trim().toLowerCase();
            }
        } catch (e) {}
        return '';
    }

    function formatDate(val) {
        if (!val) return '';
        try {
            var d = new Date(val);
            if (isNaN(d.getTime())) return String(val);
            return d.toLocaleDateString('it-IT', { day: 'numeric', month: 'short', year: 'numeric' });
        } catch (e2) {
            return String(val);
        }
    }

    function mountSearchSection() {
        var main = document.getElementById('site-main');
        if (!main) return null;
        var inner = main.querySelector('.inner.posts') || main;
        inner.innerHTML =
            '<section id="vg-funding-search" class="appaltimap-cronologia" aria-label="Elenco finanziamenti">' +
            '<h2 id="vg-funding-search-results" class="appaltimap-search-results-title">Finanziamenti e incentivi</h2>' +
            '<p class="vg-funding-search__hint" data-vg-funding-search-hint></p>' +
            '<div id="vg-funding-tabulator" style="margin-top:16px;">Caricamento…</div>' +
            '</section>';
        try {
            var anchor = document.getElementById('vg-funding-search-results');
            if (anchor && anchor.scrollIntoView) {
                anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        } catch (eScroll) {}
        return '#vg-funding-tabulator';
    }

    function setHint(regionSlug) {
        var el = qs('[data-vg-funding-search-hint]');
        if (!el) return;
        if (!regionSlug) {
            el.textContent = 'Filtro: tutta Italia — solo bandi in corso con scadenza nota.';
        } else {
            el.textContent =
                'Filtro: bandi regionali in corso per «' +
                regionSlug +
                '» (con scadenza) più bandi nazionali aperti.';
        }
    }

    function isFundingCallInProgress(row) {
        if (!row) return false;
        var st = String(row.status || '').toUpperCase();
        if (!st || st !== 'OPEN') return false;
        var s = row.deadline ? String(row.deadline).trim() : '';
        if (!s) return false;
        var m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (m) {
            var now = new Date();
            var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            var dl = new Date(parseInt(m[1], 10), parseInt(m[2], 10) - 1, parseInt(m[3], 10));
            return dl.getTime() >= today.getTime();
        }
        var t = new Date(s).getTime();
        return isFinite(t) && t >= Date.now();
    }

    function fetchAllCalls(regionSlug) {
        var url = apiRoot() + '/funding-calls?in_progress=1&status=OPEN&limit=2000&offset=0';
        if (regionSlug) {
            url += '&region_slug=' + encodeURIComponent(regionSlug);
        }
        var headers = { Accept: 'application/json' };
        var mem = memberUuid();
        if (mem) {
            headers['X-Member-UUID'] = mem;
        }
        return fetch(url, { credentials: 'include', headers: headers }).then(function (r) {
            if (!r.ok) {
                var err = new Error('HTTP ' + r.status);
                err.status = r.status;
                err.url = url;
                return r
                    .json()
                    .catch(function () {
                        return {};
                    })
                    .then(function (body) {
                        err.detail = body && body.detail ? String(body.detail) : '';
                        throw err;
                    });
            }
            return r.json();
        });
    }

    function runSearch() {
        var regionSlug = readRegionSlug();
        setHint(regionSlug);
        var mountSel = mountSearchSection();
        if (!mountSel) return;

        if (typeof window.Tabulator === 'undefined') {
            var mountErr = document.querySelector(mountSel);
            if (mountErr) mountErr.textContent = 'Tabulator non disponibile. Ricarica la pagina.';
            return;
        }

        fetchAllCalls(regionSlug)
            .then(function (data) {
                var rows = ((data && data.items) || []).filter(isFundingCallInProgress);
                var table = new window.Tabulator(mountSel, {
                    data: rows,
                    index: 'procedure_id',
                    layout: 'fitColumns',
                    pagination: true,
                    paginationSize: 25,
                    paginationSizeSelector: [10, 25, 50, 100],
                    columns: [
                        {
                            title: '',
                            field: '_vg_lamp',
                            width: 52,
                            hozAlign: 'center',
                            headerSort: false,
                            formatter: function (cell) {
                                if (window.VistaGareKanbanLamp && window.VistaGareKanbanLamp.formatterCell) {
                                    return window.VistaGareKanbanLamp.formatterCell(cell.getRow().getData());
                                }
                                return '';
                            }
                        },
                        {
                            title: 'Titolo',
                            field: 'title',
                            minWidth: 220,
                            formatter: function (cell) {
                                var d = cell.getRow().getData();
                                var t = (d.title || '').trim() || '—';
                                if (d.ghost_url) {
                                    return (
                                        '<a href="' +
                                        String(d.ghost_url).replace(/"/g, '&quot;') +
                                        '" target="_blank" rel="noopener">' +
                                        t +
                                        '</a>'
                                    );
                                }
                                return t;
                            }
                        },
                        { title: 'Tipo', field: 'type', width: 100 },
                        { title: 'Regione', field: 'region', width: 140 },
                        {
                            title: 'Scadenza',
                            field: 'deadline',
                            width: 110,
                            formatter: function (cell) {
                                return formatDate(cell.getValue());
                            }
                        },
                        { title: 'Fonte', field: 'source', width: 120 }
                    ]
                });

                if (window.VistaGareKanbanLamp && window.VistaGareKanbanLamp.wireTabulator) {
                    window.VistaGareKanbanLamp.wireTabulator(table);
                }

                table.on('rowClick', function (e, row) {
                    if (e.target && e.target.closest('[data-vg-kanban-lamp]')) return;
                    var d = row.getData();
                    if (d && d.ghost_url) {
                        window.open(d.ghost_url, '_blank', 'noopener');
                    }
                });
            })
            .catch(function (err) {
                var mount = document.querySelector(mountSel);
                if (!mount) return;
                var msg = 'Errore caricamento elenco: ' + (err && err.message ? err.message : err);
                if (err && err.status === 404) {
                    msg =
                        'Endpoint API non disponibile (HTTP 404). ' +
                        'Aggiorna e riavvia il gateway (route GET /funding-calls) e applica la migration 020_funding_calls_region_slug.sql.';
                } else if (err && err.status === 401) {
                    msg = 'Accesso non autorizzato. Accedi con un account Radar a pagamento.';
                } else if (err && err.status === 403) {
                    msg = 'Funzione riservata agli abbonati Radar a pagamento.';
                } else if (err && err.detail) {
                    msg += ' — ' + err.detail;
                }
                mount.textContent = msg;
            });
    }

    function init() {
        var btn = document.querySelector('[data-funding-action="search-list"]');
        if (!btn) return;
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            runSearch();
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})(window, document);
